import React from "react"
import Text from "@amzn/meridian/text";
import {FormattedMessage} from "react-intl";
import Column from "@amzn/meridian/column";
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";

const MetricViewV2 = (props) => {
    const {headerFont} = useDeviceLayout()

    return (
        <Column spacing="small">
            <Text type={headerFont}>
                <FormattedMessage id={props.data.headerId} defaultMessage={props.data.defaultHeader} />
            </Text>
            <Text type="d50">{props.data.metricValue}</Text>
        </Column>
    )
}

export default MetricViewV2


// WEBPACK FOOTER //
// ./src/components/outboundassociate/MetricViewV2.js